module.exports = __webpack_public_path__ + "static/img/img_culture_d.4e63cb4d.png";